// Tenant branding for the signed-in customer.
//
// Core exposes usePortalConfig(tenantId) — explicit, so it does not need to
// know how this app stores its session. This bridges the two: the store knows
// the active tenant, core knows how to fetch its config.

import { usePortalConfig } from '@invoiceflow/portal-core';
import { useAuthStore } from '../stores/useAuthStore';

export function useTenantConfig() {
  const tenantId = useAuthStore(state => state.activeTenantId);
  return usePortalConfig(tenantId ?? undefined);
}

export { usePortalConfig };
